import React from 'react'
import injectSheet from 'react-jss'
import style from './style'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Header from 'components/CameraModelSelector/Header'
import { FixedSizeList as List } from 'react-window'
import AutoSizer from 'react-virtualized-auto-sizer'
import sortBy from 'ramda/src/sortBy'
import isEmpty from 'ramda/src/isEmpty'
import complement from 'ramda/src/complement'

const subjectLine = (search, modelType) => complement(isEmpty)(search) ? `${modelType} Controller Model To Add - model ${search}` : `${modelType} Controller Model To Add`
const messageLine = (search, modelType) => complement(isEmpty)(search) ? `Please add ${modelType} controller model ${search}` : 'Please add'
const linkText = search => complement(isEmpty)(search) ? search : 'a missing model'

const NoMatch = ({ search, selectedManufacturer, modelType, classes }) =>
  <div className={classes.noMatch}>
    <div className={classes.line1}>
      { selectedManufacturer ? `No matching ${selectedManufacturer} models!` : 'No matching models!' }
    </div>
    <hr className={classes.break} />
    <a
      href={`${IPVM_URL}/contact?subject=${subjectLine(search, modelType)}&message=${messageLine(search, modelType.toLowerCase())}`}
      target='_blank'
      className={classes.missingModelButton}
    >
      Want us to add {linkText(search)}?
      <br />
      Let us know
    </a>
  </div>

const ListItem = ({ data, index, style }) => {
  const { models, selectedModel, setModel, usages, recentModels, favoriteModels, addingExpansion, expansionSelector, classes } = data
  const model = models[index]
  const showWarning = !addingExpansion && Object.keys(usages).some(limitType => usages[limitType] > model.limits[limitType])

  return (
    <div
      onClick={_ => setModel(model)}
      className={selectedModel && selectedModel.id === model.id ? classes.selected : (index % 2 === 0 ? classes.listItemOdd : classes.listItemEven)}
      style={style}
    >
      <span className={classes.modelName}>{expansionSelector ? model.text : model.model}</span>
      { recentModels.includes(model.id) && <FontAwesomeIcon icon={'history'} className={classes.clock} /> }
      { favoriteModels.includes(model.id) && <FontAwesomeIcon icon='star' className={classes.star} /> }
      { showWarning && <FontAwesomeIcon icon='exclamation-triangle' className={classes.warning} /> }
    </div>
  )
}

const ModelList = ({ models, selectedModel, setModel, usages, recentModels, favoriteModels, search, selectedManufacturer, expansionSelector, addingExpansion, classes }) =>
  <div className={expansionSelector ? classes.expansionContainer : classes.container}>
    <Header title='Models' />
    { isEmpty(models)
      ? <div className={classes.list}>
          <NoMatch
            search={search}
            selectedManufacturer={selectedManufacturer}
            modelType={expansionSelector ? 'Expansion' : 'Door'}
            classes={classes}
          />
        </div>
      : <div style={{ flex: '1 1 auto' }}>
          <AutoSizer disableWidth>
            {({ height }) => (
              <List
                height={height}
                itemCount={models.length}
                itemData={{
                  models: sortBy(m => recentModels.includes(m.id) ? (favoriteModels.includes(m.id) ? 0 : 1) : (favoriteModels.includes(m.id) ? 2 : 3))(models),
                  selectedModel,
                  setModel,
                  usages,
                  recentModels,
                  favoriteModels,
                  expansionSelector,
                  addingExpansion,
                  classes
                }}
                itemSize={27}
                width={'100%'}
                className={classes.list}
              >
                { ListItem }
              </List>
            )}
          </AutoSizer>
        </div>
    }
  </div>

export default injectSheet(style)(ModelList)



// WEBPACK FOOTER //
// ./src/components/DoorControllerModelSelector/ModelList/index.js